<template lang="pug">
  .dropdown.dropdown-right
    a.btn.btn-action.btn-sm.btn-primary.dropdown-toggle(tabindex="0")
      i.fas.fa-cog
    ul.menu.text-left
      li.menu-item(v-for="option in options" :key="option.event" v-if="option.show")
        a.c-hand(@click="$emit(option.event, balance)" :class="option.class")
          i(:class="option.icon")
          |  {{ option.label }}
</template>

<script>
export default {
  props: { balance: { type: Object, required: true } },
  computed: {
    options() {
      return [
        {
          event: 'refreshBalance',
          label: 'Recalcular este balanço',
          class: '',
          icon: 'fas fa-fw fa-sync-alt',
          show: this.balance.status === 'opened',
        },
        {
          event: 'payBalance',
          label: 'Pagar este balanço',
          class: 'text-success',
          icon: 'fas fa-fw fa-hand-holding-usd',
          show: ['closed', 'error'].includes(this.balance.status),
        },
      ]
    },
  },
}
</script>

<style lang="stylus" scoped>
.dropdown .menu
  width 250px
</style>
